<template>
<div class = "navbar-width">
<nav class="navbar navbar-expand-lg navbar-light">
  <a class="navbar-brand manrope" href="#">Hoof</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item active">
        <a class="nav-link manrope" href="/about"><del>About</del><span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active">
        <a class="nav-link manrope" href="#"><del>Features</del><span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active">
        <a class="nav-link manrope" href="#"><del>Testimonials</del><span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active">
        <a class="nav-link manrope" href="#"><del>FAQ</del><span class="sr-only">(current)</span></a>
      </li>
    </ul>
  </div>
</nav>
</div>

<div class="card mb-3 screen-center card-size border-0">
  <div class = "container">
  <div class="row g-0 screen-center">
        <div class="col-md-5">
        <div class="card-body">
        <br> 
        <br>
        <br>
        <h1 class="card-title">The Future of Personal Finance.</h1>
        <p class="card-text paragraph-size">Your finances, rewarded.</p>
        <p class="card-text paragraph-size">Built by people who get it.</p>
        <p class="card-text"><small class="text-muted">Last updated 06/17/2026</small></p>
        <p class="card-text"><small class="text-muted">Coming soon</small></p>
        <!-- <button type="button" class="btn btn-primary rounded-pill btn-lg" id="turtle-app-store">App Store</button>
        <br><br>
        <button type="button" class="btn btn-primary rounded-pill btn-lg" id="turtle-play-store">Play Store</button> -->
      </div>
    </div>
    <div class="col-md-5">
      <video autoplay muted playsinline loop>
          <source src="./assets/Hoof_Recording_Final.mp4" type="video/mp4">
      </video>
    </div>
  </div>
</div>
</div>

<br>
<div class = "grey">
<div class = "statistic-div">
  <br>
  <br>
  <h2 class = "statistic">Financial pressures continued to grow in early 2026, as 37,121 Canadians filed for consumer insolvency in the first quarter alone - the highest quarterly volume of consumer insolvencies since 2009.</h2>
  <br>
  <p class = "source"><small class="text-muted">Source: Office of the Superintendent of Bankruptcy Canada (Q1 2026 Insolvency Statistics)</small></p>
  <br>
</div>
</div>
<br>
<br>
<br>

<div class="card mb-3 card-size screen-center slide-left border-0">
  <div class = "container">
  <div class="row g-0 screen-center">
    <div class="col-md-4 order-md-2">
      <img src="./assets/3D_Pig.png" class="img-fluid rounded-start model" alt="...">
    </div>
    <div class="col-md-6 order-md-1">
      <div class="card-body">
        <h3 class="card-title">Reward financial progress, not just spending.</h3>
        <p class="card-text paragraph-size">Track your savings, investments, and financial goals automatically. Hoof celebrates the milestones that move you closer to financial freedom.</p>
      </div>
    </div>
  </div>
</div>
</div>

<div class="card mb-3 card-size screen-center slide-right border-0">
  <div class="container">
  <div class="row g-0 screen-center">
    <div class="col-md-4">
      <img src="./assets/3D_Bank.png" class="img-fluid rounded-start model" alt="...">
    </div>
    <div class="col-md-6">
      <div class="card-body">
        <h3 class="card-title">Understand where your money is going.</h3>
        <p class="card-text paragraph-size">Connect your accounts, monitor your spending habits, and uncover opportunities to save more each month.</p>
      </div>
    </div>
  </div>
  </div>
</div>

<div class="card mb-3 card-size screen-center slide-left border-0">
    <div class="container">
  <div class="row g-0 screen-center">
    <div class="col-md-4 order-md-2">
      <img src="./assets/3D_Graph.png" class="img-fluid rounded-start model-larger" alt="...">
    </div>
    <div class="col-md-6 order-md-1">
      <div class="card-body">
        <h3 class="card-title">Let AI guide your budget.</h3>
        <p class="card-text paragraph-size">Receive personalized insights, uncover spending patterns, and discover practical ways to save more and reach your goals faster.</p>
      </div>
    </div>
  </div>
  </div>
</div>

<div class="card mb-3 card-size screen-center slide-right border-0">
  <div class="container">
  <div class="row g-0 screen-center">
    <div class="col-md-4">
      <img src="./assets/3D_Coin.png" class="img-fluid rounded-start model" alt="...">
    </div>
    <div class="col-md-6">
      <div class="card-body">
        <h3 class="card-title">Turn milestones into rewards.</h3>
        <p class="card-text paragraph-size">Whether you're growing your TFSA, building an emergency fund, or saving for a major purchase, Hoof rewards the progress you make along the way.</p>
      </div>
    </div>
  </div>
  </div>
</div>
<br>
<br>
  <h2 class = "statistic">Waitlist coming soon.</h2>


<br>
<!-- <div class = "wavy-grey">
<img src = "./assets/wave.svg" class = "wave">
  <br>
  <br>
  <div class = "quote-div">
  <h2 class = "statistic">{{ quote }}</h2>
</div>
  <div class = "container">
    <div class = "row screen-center">
  <div v-on:click = "previousQuote" class = "rounded-circle circle-button" v-on:mouseenter="activateLeft()" v-bind:class = "{'button-hover': isLeftActive}" v-on:mouseleave="activateLeft()">
    <img class = "arrow" v-bind:src = "leftArrow">
  </div>
    <div v-on:click = "nextQuote" class = "rounded-circle circle-button" v-on:mouseenter="activateRight()" v-bind:class = "{'button-hover': isRightActive}" v-on:mouseleave="activateRight()">
      <img class = "arrow" v-bind:src = "rightArrow">
    </div>
</div>
</div>
  <img src = "./assets/wave-2.svg" class = "wave">
</div> -->
<br>

</template>

<script>

import leftArrowBlack from '@/assets/left-arrow-black.png'
import leftArrowWhite from '@/assets/left-arrow-white.png'
import rightArrowBlack from '@/assets/right-arrow-black.png'
import rightArrowWhite from '@/assets/right-arrow-white.png'

export default {
  mounted() {
    document.title = "Hoof | Your finances, rewarded.";
    this.boxes = document.querySelectorAll(".card-size.screen-center");
    window.addEventListener('scroll', this.checkBoxes);
  },

  data() {
    return {
      boxes: [],
      quotes: [
      "I love the daily journaling prompts. Tracking my moods showed patterns I never noticed — now I can stop anxiety before it spirals.",
      "Useful features — journaling, challenges, community — but the onboarding threw a lot at me at once. Once I learned it, it helped.",
      "I completed a 14-day challenge and my panic attacks dropped dramatically. The progress graphs kept me motivated to continue.",
      "Doing challenges with my best friend made exposure therapy fun instead of terrifying. The leaderboard is silly but motivating.",
      "I appreciate the private journaling and the no-pressure challenges. The AI photo prompts nudge me to leave my comfort zone gently.",
      "Short breathing exercises + daily motivational quotes = instant calm on tough days. Would like more long-form therapy-style modules.",
      "Turtle helped me spot triggers and build confidence — fast breathing, daily logs, and smart exposure tasks that actually work."
      ],
      quoteCount: 0,
      isLeftActive: false,
      isRightActive: false,
      leftArrow: leftArrowBlack,
      rightArrow: rightArrowBlack
    }
  },

  methods: {
    checkBoxes() {
      const triggerBottom = window.innerHeight / 5 * 4;

      this.boxes.forEach(box => {
        const boxTop = box.getBoundingClientRect().top;

        if (boxTop < triggerBottom) {
          box.classList.add('show');
        } else {
          box.classList.remove('show');
        }
      })
    },
    nextQuote() {
      if (this.quoteCount < this.quotes.length-1) {
        this.quoteCount += 1;
      } else {
        this.quoteCount = 0;
      }
    },
    previousQuote() {
      if (this.quoteCount == 0) {
        this.quoteCount = this.quotes.length - 1;
      } else {
        this.quoteCount -= 1;
      }
    },
    activateLeft() {
      this.isLeftActive = !this.isLeftActive;
      if (this.leftArrow == leftArrowBlack) {
        this.leftArrow = leftArrowWhite
      } else {
        this.leftArrow = leftArrowBlack
      }
    },
    activateRight() {
      this.isRightActive = !this.isRightActive;
      if (this.rightArrow == rightArrowBlack) {
        this.rightArrow = rightArrowWhite
      } else {
        this.rightArrow = rightArrowBlack
      }
    }
  },
  computed: {
    quote() {
      return this.quotes[this.quoteCount];
    }
  }

}
</script>

<style>

#app {
  margin-top: 0;
}

.navbar-width {
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}


.manrope {
  font-family: "Manrope", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}


.montserrat {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.card-size {
  max-width: 180vh;
}

.paragraph-size {
  font-size: large;
}

#turtle-app-store {
  background-color: #85c61b;
  border-color: #85c61b;
}

#turtle-play-store {
  background-color: black;
  border-color: black;
}

.screen-center {
  justify-content: center;
  align-items: center;
}

.slide-right {
  transform: translateX(400%);
  transition: transform 0.8s ease;
}

.slide-left {
  transform: translateX(-400%);
  transition: transform 0.8s ease;
}

.slide-right.show {
  transform: translateX(0);
}

.slide-left.show {
  transform: translateX(0);
}

.statistic-div {
  max-height: 500px;
  margin: auto;
  width: 80%;
  /* background-color: #fcefb3; */
}

.statistic {
  text-align: center;
  font-size: clamp(1.25rem, 4vw, 2rem);
}

.grey {
  max-width: 200vh;
  /* background-color: #fcefb3; */
}

.wavy-grey {
  max-width: 200vh;
  background-color: #f5f5f5;
}

.statistic-clipboard {
  display: block;
  margin: auto;
  width: 50px;
}

.quote-div {
  margin: auto;
  width: 80%;
  height: 100px;
}

.circle-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 60px;
  margin: 20px;
  border: 1px solid black;
}

.arrow {
  display: block;
  width: 50%;
  margin: auto;
}

.button-hover {
  background-color: #87db84;
  cursor: pointer;
  border: 0px;
}

html, body, template {
  max-width: 100%;
  overflow-x: hidden;
  background-color: #FFFFFF;
}

video {
  width: 100%;
  max-width: 400px;
  clip-path: inset(1px);
}

.model {
  display: block;
  margin: auto;
  width: 275px;
}

.model-larger {
  display: block;
  margin: auto;
  width: 350px;
}

.model-largest {
  display: block;
  margin: auto;
  width: 350px;
}

.source {
  text-align: center;
  font-size: 1.5rem;
  line-height: 110%;
}

</style>
